import React from "react";
import Test from "./test";

const info = {
  difficulty: "medium",
  title: "Deep Filter Object",
  url: "deep-filter-object",
  problemNumber: 1,
  problem: React.lazy(() => import(`./problem`)),
  test: Test,
  starter: `/**
* @param {object {}} obj
* @param {function()} filter
* @return {object}
*/
    
/**
* Do not change this function body
* Do your changes within the function 
*/

return function deepFilter(obj, filter) {
  // your code goes here        
};
`,
};

export default info;
